export const yesNoOptions = [
  {
    code: "Yes",
    key: "Yes",
    value: true,
    label: "Yes"
  },
  {
    code: "No",
    key: "No",
    value: false,
    label: "No"
  }
];

export const YesNoList = [
  {
    code: "Yes",
    key: "Yes",
    value: "Yes",
    label: "Yes"
  },
  {
    code: "No",
    key: "No",
    value: "No",
    label: "No"
  }
];

export const baseLocation = [
  {
    code: "UAE",
    key: "UAE",
    value: "UAE",
    label: "Within UAE"
  },
  {
    code: "NON-UAE",
    key: "NON-UAE",
    value: "NON-UAE",
    label: "Outside UAE"
  }
];
